import { render } from "./ContentEdit.vue?vue&type=template&id=bad60ee2"
import script from "./ContentEdit.vue?vue&type=script&lang=js"
export * from "./ContentEdit.vue?vue&type=script&lang=js"
script.render = render

export default script